import {
  Box,
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { React, useEffect } from "react";
import { sizes } from "../approvalUtils";
import { useDispatch, useSelector } from "react-redux";
import { getQuotaForApproval, setState } from "./quotaSlice";
import { useParams } from "react-router-dom";
import { useLocation } from "react-router-dom";

const selectWidth = sizes.w200;
const selectHeight = sizes.h35;

export default function Form() {
  const { paramsCountryID } = useParams();
  const dispatch = useDispatch();
  const location = useLocation();
  const state = useSelector((state) => state.quota);
  const {
    countries,
    selectedCountry,
    selectedCountryID,
    quotaStatusList,
    selectedQuotaStatus,
    periods,
    selectedPeriod,
    searchText,
    navigatedCountryID,
  } = state;

  const loginState = useSelector((store) => store.login);
  const { globalSelectedCountryName,globalSelectedCountryID,} = loginState    

	useEffect(() => {
		if (location.state) {
      //console.log("Quota", location.state);
			dispatch(setState("selectedCountry", location.state.selectedCountry));
			dispatch(setState("selectedCountryID", location.state.selectedCountryID));
      const logedUser = JSON.parse(localStorage.getItem("data"));
      const countryId = location.state.selectedCountryID;
      const period = selectedPeriod;
      const quotaStatus = selectedQuotaStatus;
  
      const obj = {
        countryId,
        period,
        quotaStatus,
        logedUser,
        searchText: searchText,
      };
      dispatch(getQuotaForApproval(obj));
		}
	}, [location]);

  useEffect(() => {
    if(globalSelectedCountryName !==null && globalSelectedCountryName !== "" ){
        dispatch(setState("selectedCountry", globalSelectedCountryName));
        dispatch(setState("selectedCountryID", globalSelectedCountryID));
        dispatch(setState("QAGlobalCountryID", globalSelectedCountryID));
    }
    else{
      dispatch(setState("selectedCountry", ""));
      dispatch(setState("selectedCountryID", ""));
      dispatch(setState("QAGlobalCountryID", ""));    
    }
}, [globalSelectedCountryID]);   

  function setCountry(event) {
    dispatch(setState("quotaForApproval", []));
    dispatch(setState("quotaForApprovalTable", null));
    dispatch(setState("quotaCustomerBreakdown", null));
    dispatch(setState("quotaDetailsTable", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    dispatch(setState("navigatedCountryID", ""));
    const name = event.target.value;
    let id = 0;
    if (name !== "All") {
      id = countries.find((country) => country.countryName === name).countryID;
    }
    dispatch(setState("selectedCountry", name));
    dispatch(setState("selectedCountryID", id));
  }

  function setQuotaStatus(event) {
    dispatch(setState("quotaForApproval", []));
    dispatch(setState("quotaForApprovalTable", null));
    dispatch(setState("quotaCustomerBreakdown", null));
    dispatch(setState("quotaDetailsTable", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const name = event.target.value;
    const key = quotaStatusList.find((status) => status.value === name).key;
    dispatch(setState("selectedQuotaStatus", name));
    dispatch(setState("selectedQuotaStatusKey", key));
  }

  function setPeriod(event) {
    dispatch(setState("quotaForApproval", []));
    dispatch(setState("quotaForApprovalTable", null));
    dispatch(setState("quotaCustomerBreakdown", null));
    dispatch(setState("quotaDetailsTable", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const name = event.target.value;
    const key = periods.find((status) => status.value === name).key;
    dispatch(setState("selectedPeriod", name));
    dispatch(setState("selectedPeriodKey", key));
  }
  const showMessage = (message, severity) => {
    dispatch(setState("message", message));
    dispatch(setState("severity", severity));
    dispatch(setState("messageOpen", true));
  };

  function search() {
    if (selectedQuotaStatus === null || selectedQuotaStatus === "") {
      showMessage("Please select Quota status", "info");
      return;
    } else if (selectedCountryID === null || selectedCountryID === "") {
      showMessage("Please select country", "info");
      return;
    } else if (selectedPeriod === null || selectedPeriod === "") {
      showMessage("Please select period", "info");
      return;
    }
    dispatch(setState("quotaForApproval", []));
    dispatch(setState("quotaForApprovalTable", null));
    dispatch(setState("quotaCustomerBreakdown", null));
    dispatch(setState("quotaDetailsTable", null));
    dispatch(setState("rejectSelectedComment", ""));
    dispatch(setState("selectedRows", []));
    const logedUser = JSON.parse(localStorage.getItem("data"));
    const countryId = selectedCountryID;
    const period = selectedPeriod;
    const quotaStatus = selectedQuotaStatus;

    const obj = {
      countryId,
      period,
      quotaStatus,
      logedUser,
      searchText: searchText,
    };
    dispatch(getQuotaForApproval(obj));
  }
  function setSearchText(event) {
    const text = event.target.value;
    dispatch(setState("searchText", text));
  }

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container columns={9} spacing={2}>
        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Quota Status</InputLabel>
            <Select
              value={selectedQuotaStatus}
              label="Quota Status"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setQuotaStatus}
            >
              {quotaStatusList.map((status, index) => {
                return (
                  <MenuItem key={index} value={status.value}>
                    {status.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Country</InputLabel>
            <Select
              value={selectedCountry}
              label="Country"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setCountry}
            >
              <MenuItem value={"All"}>{"All"}</MenuItem>
              {countries.map((country, index) => {
                return (
                  <MenuItem key={index} value={country.countryName}>
                    {country.countryName}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid item sm={2}>
          <FormControl>
            <InputLabel>Period</InputLabel>
            <Select
              value={selectedPeriod}
              label="Period"
              sx={{
                height: selectHeight,
                width: selectWidth,
                color: "black.main",
                mt: 1,
              }}
              onChange={setPeriod}
            >
              {periods.map((period, index) => {
                return (
                  <MenuItem key={index} value={period.value}>
                    {period.value}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
        <Grid item sm={2}>
          <TextField
            placeholder="Type your search"
            inputProps={{
              sx: {
                p: 2,
                width: selectWidth,
                height: selectHeight,
              },
            }}
            value={searchText}
            onChange={setSearchText}
          />
        </Grid>

        <Grid item sm={1}>
          <Button
            // startIcon={<ManageSearchIcon />}
            sx={{
              bgcolor: "darkred.light",
              color: "white.main",
              textTransform: "none",
              fontWeight: "bold",
              "&:hover": {
                bgcolor: "darkred.main",
                color: "white.main",
              },
            }}
            onClick={search}
          >
            Search
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}
